import { render, staticRenderFns } from "./SelectServiceTypeShippingMethod.vue?vue&type=template&id=3ca7648a&"
import script from "./SelectServiceTypeShippingMethod.vue?vue&type=script&lang=js&"
export * from "./SelectServiceTypeShippingMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports